<template>
  <section class="con--create-basic">
    <v-container grid-list-md>
      <v-form v-model="valid" @submit="createCompany">
        <v-layout row wrap>
          <v-flex sm12>
            <div class="con--create-header">
              <div class="con--create-header-grid">
                <div>
                  <p class="con--create-subtitle">Create A New</p>
                  <p class="con--create-title">Company</p>
                </div>
                <div class="con--create--header--span-3">
                  <p class="con--create-subtitle">Company Creator</p>
                  <p class="con--create-title">{{ this['user/user'].name }}</p>
                </div>
                <div class="con--create--header--span-2">
                  <v-btn depressed color="primary" type="submit" :disabled="!valid">Save</v-btn>
                  <v-btn depressed color="primary" disabled>Save And New</v-btn>
                </div>
              </div>
            </div>
            </v-flex>
            <v-flex sm12 md12 lg12>
              <v-card class="con--create-card">
                <p>BASICS</p>
                <div class="con--create-pd">
                  <div class="con--create-grid-2">
                    <div>
                      <v-text-field label="NAME" :rules="nameRules" v-model="form.name" />
                    </div>
                    <div>
                      <v-text-field label="LOGO" :rules="logoRules" v-model="form.logo" :required="false" />
                    </div>
                    <div>
                      <v-text-field label="ADDRESS" :rules="addrRules" v-model="form.address" :required="false" />
                    </div>
                    <div>
                      <v-text-field label="PHONE" :rules="phoneRules" v-model="form.phone" :required="false" />
                    </div>
                  </div>
                </div>
              </v-card>
            </v-flex>
            <!-- <v-flex sm12 md6 lg6>
              <v-card class="con--create-card">
                <p>NOTES</p>
                <div class="con--create-pd">
                  <div class="con--create-note">
                    <v-text-field box multi-line rows="7" />
                  </div>
                </div>
              </v-card>
            </v-flex> -->
        </v-layout>
      </v-form>
    </v-container>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import checkPhone from "validator/lib/isMobilePhone";
import { coreClient } from "../../apollo";
import gql from "graphql-tag";
export default {
  data() {
    return {
      valid: false,
      form: {
        name: "",
        logo: "",
        address: "",
        phone: ""
      },
      nameRules: [
        v => !!v || "Name is required.",
        v => v.length > 1 || "Name must be more than a character."
      ],
      logoRules: [
        v =>
          v
            ? /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/.test(
                v
              ) || "Please enter a valid link."
            : true
      ],
      addrRules: [
        v =>
          v
            ? v.length > 5 || "Address must atleast be 5 characters long."
            : true
      ],
      phoneRules: [
        v => (v ? checkPhone(v) || "Phone No. must be valid." : true)
      ]
    };
  },
  methods: {
    async createCompany(evt) {
      evt.preventDefault();
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation createCompany(
              $name: String!
              $logo: String
              $address: String
              $phone: String
            ) {
              createCompany(
                name: $name
                logo: $logo
                address: $address
                phone: $phone
              ) {
                id
                name
                logo
                address
                phone
              }
            }
          `,
          variables: this.form
        });

        const { createCompany } = data;

        setTimeout(() => {
          this.$router.push("/company/" + createCompany.id);
        }, 500);
      } catch (e) {
        // handle this later, if it happens.
      }
    }
  },
  computed: {
    ...mapGetters(["user/user"])
  }
};
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/Company_create.styl';
</style>
